import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card.tsx";
import { Separator } from "@/components/ui/separator.tsx";
import { Prize } from "@/types/prize.ts";
import { useTranslation } from "@/i18n";

const PrizeCard = ({ prize }: { prize: Prize }) => {
  const { t } = useTranslation();
  const isPercentage = prize.monetary_value_type === "percentage";
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>{prize.description}</CardTitle>
        <CardDescription>{prize.notes}</CardDescription>
      </CardHeader>
      <Separator />
      <CardContent className="flex items-center gap-2">
        {prize.type === "monetary" && (
          <>
            <div className="text-sm font-bold">{t("prize.value")}</div>
            <div>
              {isPercentage
                ? t("prize.percentageValue", {
                    value: prize.value,
                    netOrGross: prize.net_or_gross,
                  })
                : t("common.price", { amount: prize.value })}
            </div>
          </>
        )}
      </CardContent>
      <Separator />
      <CardFooter className="flex flex-col">
        <div className="font-bold">{t("prize.winners")}</div>
        {prize.winners.length ? (
          <div>
            {prize.winners.map((winner) => (
              <div className="flex gap-4">
                <div>
                  {t("prize.ticketNumber")}{" "}
                  <span className="font-bold">{winner.number}</span>
                </div>
                {!!winner.user && (
                  <div>
                    {t("prize.winnerFrom", {
                      name: winner.user.name,
                      city: winner.user.city,
                    })}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div>{t("prize.winnersPending")}</div>
        )}
      </CardFooter>
    </Card>
  );
};

export default PrizeCard;
